import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { ICE_TASK_BASE_PATH } from '../../../../../../../../../features/vendor/ice/task/ice-task-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/ice/task/_task')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'ice-task-list',
        label: 'ICE',
        to: ICE_TASK_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
